<template>
	<van-popup v-model:show="visiable" round position="bottom" :close-on-click-overlay="false">
		<div class="wrap" v-loading="loading" style="height: 60vh;">
			<st-form ref="form">
				<div class="topper">
					<div style="float:left;width: 60px;cursor: pointer;" @click="cancel">取消</div>
					<div style="float:right;width: 60px;color: #62abd6;cursor: pointer;" @click="submit">确定</div>
				</div>
				<div class="form-body" style="padding-left: 26px;">
					<van-cell-group>
						<st-form-item key="contract_files" label="发票" prop="contract_files">
							<st-file-upload
								v-model="invoiceArr"
							>
							</st-file-upload>
						</st-form-item>
					</van-cell-group>
				</div>
			</st-form>
		</div>
	</van-popup>
</template>

<script>
import StFileUpload from "@/components/FileUpload.vue";
import StFormItem from "@/components/formItem.vue";
import StForm from "@/components/form.vue";
export default {
  components: {
		StForm,
		StFileUpload,
		StFormItem
	},
  props: {
    id: {
      type: [String, Number],
      default: () => {
        return '';
      }
    },
		visiable: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
  },
  data() {
    return {
			loading: false,
			invoiceArr: [],
    };
  },
  created() {
    this.init();
  },
  mounted() {
  },
  watch: {},
  methods: {
		init() {
			this.getInfo();
		},
		getInfo() {
			this.loading = true;
			this.$post(this.$api.stPurchaseInfo, { id: this.id }).then((res) => {
			  if (res.code !== 1) {
			    this.$toast.fail(res.msg ? res.msg : '网络请求异常，请稍后重试');
			  }
				this.invoiceArr = res.data.purchase_order.invoice_files_list;
			  this.loading = false;
			});
		},
		// 上传发票
		submit() {
			this.$post(this.$api.stPurchaseUpinvoice, { id: this.id, invoice_files: this.invoiceArr }).then((res) => {
			  if (res.code !== 1) {
			    this.$toast.fail(res.msg ? res.msg : '网络请求异常，请稍后重试');
			  } else {
					this.$toast.success('上传成功');
					this.$emit('update:visiable', false);
				}
				
			});
			
		},
		// 取消
		cancel() {
			this.$emit('update:visiable', false);
		},
	
  },
};
</script>


<style>
	.topper {
		margin-top: 4px;
		overflow:hidden;
		height: 40px;
		line-height: 40px;
		padding: 0px 12px;
		text-align: center;
		font-size: 16px;
	}
</style>